import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { GrTypography } from "../../inputs";
import { GrStack } from "../../layout";
import { palette } from "../../../theme/palette";
import { css, keyframes } from "@emotion/react";
import styled from "@emotion/styled";
const F = 8;
const S = 10;
const O = 2;
const X = 10;
const frames = [
    `${S - X}px -${S + O}px 0 ${S}px,
  ${S + O}px -${S + O}px 0 ${S}px,
  ${S + O}px -${S - X}px 0 ${S}px,
  -${F + O}px ${F + O}px 0 ${F}px`,
    `${S + O}px -${S + O}px 0 ${S}px,
  ${S + O}px -${S + O}px 0 ${S}px,
  ${S + O}px ${S - O}px 0 ${S}px,
  -${F + O}px ${F + O}px 0 ${F}px`,
    `${S + O}px ${S - O}px 0 ${S}px,
  ${S + O}px ${S - O}px 0 ${S}px,
  ${S + O}px ${S - O}px 0 ${S}px,
  -${F + O}px ${F + O}px 0 ${F}px`,
    `-${F}px ${S - O}px 0 ${S}px,
  -${F}px ${S - O}px 0 ${S}px,
  -${F}px ${S - O}px 0 ${S}px,
  -${F + O}px ${F + O}px 0 ${F}px`,
    `-${F}px -${S + O}px 0 ${S}px,
  -${F}px -${S + O}px 0 ${S}px,
  -${F}px -${S + O}px 0 ${S}px,
  -${F + O}px ${F + O}px 0 ${F}px`,
    `${S - X}px -${S + O}px 0 ${S}px,
  ${S + O}px -${S + O}px 0 ${S}px,
  ${S + O}px -${S + O}px 0 ${S}px,
  -${F + O}px ${F + O}px 0 ${F}px`,
    `${S - X}px -${S + O}px 0 ${S}px,
  ${S + O}px -${S + O}px 0 ${S}px,
  ${S + O}px -${S - X}px 0 ${S}px,
  -${F + O}px ${F + O}px 0 ${F}px`,
];
const keyframesAnimation = keyframes `
  ${frames.map((frame, frameIdx) => `
      ${Math.floor((frameIdx / frames.length) * 100)}% {
        box-shadow: ${frame};
      }
    `)}
  100% {
    box-shadow: ${frames[6]};
  }
`;
export const StyledAnimationLogo = styled.div(() => css `
    display: inline-block;
    position: relative;
    width: 0;
    height: 0;
    color: ${palette["maven-blue-dark"]};
    box-shadow:
      ${S - X}px -${S + O}px 0 ${S}px,
      ${S + O}px -${S + O}px 0 ${S}px,
      ${S + O}px -${S - X}px 0 ${S}px,
      -${F + O}px ${F + O}px 0 ${F}px;
    animation: ${keyframesAnimation} 1.5s infinite;
  `);
export const GrProgressLogo = ({ message }) => {
    return (_jsxs(GrStack, { display: "inline-flex", gap: "32px", justifyContent: "center", alignItems: "center", flexDirection: "column", padding: "24px 0 0", children: [_jsx(StyledAnimationLogo, {}), !!message && (_jsx(GrTypography, { type: "Content.Subtitle01", color: "grey080", children: message }))] }));
};
//# sourceMappingURL=GrProgressLogo.js.map